import { Modal } from 'almanac-ui/Modal'
import { Button } from 'components/Button'

export const ReloadPrompt = ({ onReload }: { onReload: () => Promise<void> }) => (
  <Modal.Root>
    <Modal.Header title="A new version of Blaze is available!" />
    <Modal.Content>
      We'll save all your work, but you'll need to reload the page to get the latest updates.
    </Modal.Content>
    <Modal.Footer>
      <Modal.FooterContent slot="right">
        <Button variant="primary" onPress={onReload} size="lg">
          Save and Reload
        </Button>
      </Modal.FooterContent>
    </Modal.Footer>
  </Modal.Root>
)
